/*
 * Created Date: Thu, 29th Jul 2021, 11:20:46 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2021 The Distance
 */
import recursiveMap from 'utils/recursiveMapReactChildren';
import { languageNames } from 'utils';

const enLanguageNames = languageNames(); // default is en

const validateNoMissingLocaleFields = ({
  children,
  excludedSources,
  localisations,
  sourcesToSkipRecursion,
}) => {
  let unsetFields = {};
  // check for missing fields - get each field within the multilanguage form
  // (exclude sources from localisation)
  const requiredLocalisedSources = [];
  recursiveMap(
    children,
    ({ props }) => {
      if (
        props &&
        props.source &&
        !excludedSources.includes(props.source) &&
        props.validate &&
        props.validate.isRequired
      ) {
        return requiredLocalisedSources.push(props.source);
      }
    },
    sourcesToSkipRecursion
  );

  // check that all required fields have a localisation
  if (requiredLocalisedSources && requiredLocalisedSources.length > 0) {
    requiredLocalisedSources.forEach((source) => {
      localisations.forEach((locale) => {
        if (!locale[source])
          unsetFields = {
            source,
            language: enLanguageNames.of(locale.language),
          };
      });
    });
  }
  return unsetFields;
};

export { validateNoMissingLocaleFields };
